import moment from "moment";
import {KeyConstant} from "../../../can/weighing-slip/constant/keyConstant";
import React from "react";
import 'moment/locale/vi'

const format = "DD MMM, YYYY"
const formatCompareDMY = "YYYYMMDD"
const formatCompareMY = "YYYYMM"
const formatCompareY = "YYYY"

const mapAboutDays = (startDate , endDate) =>{

    if (moment(startDate).format(formatCompareDMY) === moment(endDate).format(formatCompareDMY)){
        return <>
            <span> {moment(startDate).locale("vi").format(format)} </span>
        </>
    }
    if (moment(startDate).format(formatCompareMY) === moment(endDate).format(formatCompareMY)){
        return <>
            <span> {moment(startDate).locale("vi").format("DD")} </span> -
            <span> {moment(endDate).locale("vi").format(format)} </span>
        </>
    }
    if (moment(startDate).format(formatCompareY) === moment(endDate).format(formatCompareY)){
        return <>
            <span> {moment(startDate).locale("vi").format("DD MMM")} </span> -
            <span> {moment(endDate).locale("vi").format(format)} </span>
        </>
    }
    return <>
        <span> {moment(startDate).locale("vi").format("DD MMM, YYYY")} </span> -
        <span> {moment(endDate).locale("vi").format("DD MMM, YYYY")} </span>
    </>
}
export const mapTitleDate = (type , startDate , endDate)=>{

    switch (type){
        case KeyConstant.TODAY:
        case KeyConstant.YESTERDAY:
            return  moment(startDate).locale("vi").format("dddd, DD MMMM").charAt(0).toUpperCase() +
                moment(startDate).locale("vi").format("dddd, DD MMMM").slice(1)
        case KeyConstant.THIS_MONTH:
        case KeyConstant.LAST_MONTH:
            return moment(startDate).locale("vi").format("MMMM").charAt(0).toUpperCase() +
                moment(startDate).locale("vi").format("MMMM").slice(1)
        default :
            return mapAboutDays(startDate, endDate)
    }
}

export const mapTitleDateLast = (type , startDate , endDate)=>{

    switch (type){
        case KeyConstant.TODAY:
        case KeyConstant.YESTERDAY:
            return  moment(startDate).locale("vi").format("dddd, DD MMMM, YYYY").charAt(0).toUpperCase() +
                moment(startDate).locale("vi").format("dddd, DD MMMM, YYYY").slice(1)
        case KeyConstant.THIS_MONTH:
        case KeyConstant.LAST_MONTH:
            return moment(startDate).locale("vi").format("MMMM, YYYY").charAt(0).toUpperCase() +
                moment(startDate).locale("vi").format("MMMM, YYYY").slice(1)
        default :
            return mapAboutDays(startDate, endDate)
    }
}

export const mapPeriod = (type, startDate , endDate) =>{
    if (moment(startDate).format("YYYYMMDD") > moment(endDate).format("YYYYMMDD")){
        return moment(startDate).format("dddd, DD MMMM YYYY")
    }else{
        let dateDiff = moment(endDate).diff(moment(startDate), 'days') + 1
        let startDateTemp = moment(startDate).subtract(dateDiff, "days");
        let endDateTemp = moment(endDate).subtract(dateDiff, "days");

        return mapTitleDate(type, startDateTemp, endDateTemp);

    }
}

export const mapLastPeriod = (type, startDate , endDate) =>{
    if (moment(startDate).format("YYYYMMDD") > moment(endDate).format("YYYYMMDD")){
        return moment(startDate).format("dddd, DD MMMM YYYY")
    }else{
        let startDateTemp = moment(startDate).subtract(1, "years");
        let endDateTemp =  moment(endDate).subtract(1, "years");

        return mapTitleDateLast(type, startDateTemp, endDateTemp);

    }
}
